exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=radio][data-v-63a4c4ce]{display:none}.radio-check[data-v-63a4c4ce]{cursor:pointer}", ""]);

// exports
